import { cAPI } from '../../../utils/cAPI';
import { getData, addEditData, removeData } from '../generic';
import { setPayUEnabled, setP24Enabled } from '../../../features/appInit/slice';

export const getIntegrationP24 = () => dispatch => getData(dispatch, cAPI.APGetIntegrationP24, 'p24Integration').then(result => {
    dispatch(setP24Enabled({ p24Enabled: result.payload.enabled }));

    return result;
});
export const updateIntegrationP24 = formData => dispatch => addEditData(dispatch, cAPI.APUpdateIntegrationP24, formData, 'p24Integration');

export const getIntegrationPayU = () => dispatch => getData(dispatch, cAPI.APGetIntegrationPayU, 'payUIntegration').then(result => {
    dispatch(setPayUEnabled({ payUEnabled: result.payload.enabled }));

    return result;
});
export const updateIntegrationPayU = formData => dispatch => addEditData(dispatch, cAPI.APUpdateIntegrationPayU, formData, 'payUIntegration');

export const getIntegrationInPost = () => dispatch => getData(dispatch, cAPI.APGetIntegrationInPost);
export const updateIntegrationInPost = formData => dispatch => addEditData(dispatch, cAPI.APUpdateIntegrationInPost, formData);

export const getIntegrationAPaczka = () => dispatch => getData(dispatch, cAPI.APGetIntegrationAPaczka);
export const updateIntegrationAPaczka = formData => dispatch => addEditData(dispatch, cAPI.APUpdateIntegrationAPaczka, formData);

export const getIntegrationFurgonetka = () => dispatch => getData(dispatch, cAPI.APGetIntegrationFurgonetka);
export const updateIntegrationFurgonetka = formData => dispatch => addEditData(dispatch, cAPI.APUpdateIntegrationFurgonetka, formData);

export const getIntegrationFacebook = () => dispatch => getData(dispatch, cAPI.APGetIntegrationFacebook);
export const updateIntegrationFacebook = formData => dispatch => addEditData(dispatch, cAPI.APUpdateIntegrationFacebook, formData);

export const getCeneoSettings = () => dispatch => getData(dispatch, cAPI.APGetCeneoSettings, 'ceneoSettings');
export const updateCeneoSettings = formData => dispatch => addEditData(dispatch, cAPI.APUpdateCeneoSettings, formData, 'ceneoSettings');

export const getCeneoMappings = () => dispatch => getData(dispatch, cAPI.APGetCeneoMappings, 'ceneoMappings');
export const deleteCeneoMapping = id => dispatch => removeData(dispatch, cAPI.APDeleteCeneoMapping, id, 'ceneoMappings');
export const addCeneoMapping = formData => dispatch => addEditData(dispatch, cAPI.APAddCeneoMapping, formData, 'ceneoMappings');
export const updateCeneoCategories = () => dispatch => addEditData(dispatch, cAPI.APUpdateCeneoCategories, null, 'ceneoSettings');
export const generateCeneoXML = () => dispatch => addEditData(dispatch, cAPI.APGenerateCeneoXML , null, 'ceneoSettings');

export const getGoogleAnalytics = () => dispatch => getData(dispatch, cAPI.APGetGoogleAnalytics);
export const updateGoogleAnalytics = formData => dispatch => addEditData(dispatch, cAPI.APUpdateGoogleAnalytics, formData);

export const getFreshmail = () => dispatch => getData(dispatch, cAPI.APGetFreshmail);
export const updateFreshmail = formData => dispatch => addEditData(dispatch, cAPI.APUpdateFreshmail, formData);

export const getChatSettings = () => dispatch => getData(dispatch, cAPI.APGetChatSettings);
export const updateChatSettings = formData => dispatch => addEditData(dispatch, cAPI.APUpdateChatSettings, formData);

export const getInspectletSettings = () => dispatch => getData(dispatch, cAPI.APGetInspectletSettings);
export const updateInspectletSettings = formData => dispatch => addEditData(dispatch, cAPI.APUpdateInspectletSettings, formData);

export const getIntegrationRecaptcha = () => dispatch => getData(dispatch, cAPI.APGetIntegrationRecaptcha);
export const updateIntegrationRecaptcha = formData => dispatch => addEditData(dispatch, cAPI.APUpdateIntegrationRecaptcha, formData);

export const getIntegrationGoogleSearchConsole = () => dispatch => getData(dispatch, cAPI.APGetIntegrationGoogleSearchConsole);
export const updateIntegrationGoogleSearchConsole = formData => dispatch => addEditData(dispatch, cAPI.APUpdateIntegrationGoogleSearchConsole, formData);

export const getIntegrationCookiebot = () => dispatch => getData(dispatch, cAPI.APGetIntegrationCookiebot);
export const updateIntegrationCookiebot = formData => dispatch => addEditData(dispatch, cAPI.APUpdateIntegrationCookiebot, formData);

export const getIntegrationOpenAi = () => dispatch => getData
(
    dispatch,
    () => cAPI.exposedFetch({ path: '/Admin/Integrations/OpenAi', httpMethod: 'GET' })
);

export const updateIntegrationOpenAi = formData => dispatch => addEditData
(
    dispatch,
    payload => cAPI.exposedFetch({ path: '/Admin/Integrations/OpenAi', httpMethod: 'POST', jsonBody: payload }),
    formData
);

export const getGoogleMerchantConfiguration = () => dispatch => getData
(
    dispatch,
    () => cAPI.exposedFetch({
        path: '/Admin/Integrations/GoogleMerchant/Configuration',
        httpMethod: 'GET'
    }),
    'googleMerchantConfiguration',
    true
);

export const updateGoogleMerchantConfiguration = formData => dispatch => addEditData
(
    dispatch,
    payload => cAPI.exposedFetch({
        path: '/Admin/Integrations/GoogleMerchant/Configuration',
        httpMethod: 'PUT',
        jsonBody: payload
    }),
    formData,
    'googleMerchantConfiguration',
    false,
    false,
    true,
    true
);

export const testGoogleMerchantConnection = formData => dispatch => addEditData
(
    dispatch,
    payload => cAPI.exposedFetch({
        path: '/Admin/Integrations/GoogleMerchant/Configuration/Test',
        httpMethod: 'POST',
        jsonBody: payload
    }),
    formData,
    'googleMerchantConnection',
    false,
    false,
    true,
    true
);

export const getGoogleMerchantOAuthAuthorizationUrl = redirectUri => dispatch => getData
(
    dispatch,
    () => cAPI.exposedFetch({
        path: `/Admin/Integrations/GoogleMerchant/OAuth/AuthorizationUrl?redirectUri=${encodeURIComponent(redirectUri)}`,
        httpMethod: 'GET'
    })
);

export const completeGoogleMerchantOAuthCallback = formData => dispatch => addEditData
(
    dispatch,
    payload => cAPI.exposedFetch({
        path: '/Admin/Integrations/GoogleMerchant/OAuth/Callback',
        httpMethod: 'POST',
        jsonBody: payload
    }),
    formData,
    'googleMerchantConfiguration',
    false,
    false,
    true,
    true
);

export const disconnectGoogleMerchantOAuth = () => dispatch => addEditData
(
    dispatch,
    () => cAPI.exposedFetch({
        path: '/Admin/Integrations/GoogleMerchant/OAuth',
        httpMethod: 'DELETE'
    }),
    null,
    'googleMerchantConfiguration',
    false,
    false,
    true,
    true
);

export const createGoogleMerchantProfilesForActiveLanguages = () => dispatch => addEditData
(
    dispatch,
    () => cAPI.exposedFetch({
        path: '/Admin/Integrations/GoogleMerchant/Configuration/Profiles/CreateForActiveLanguages',
        httpMethod: 'POST'
    }),
    null,
    'googleMerchantConnection',
    false,
    false,
    true
);

export const createGoogleMerchantDataSourceForProfile = profileId => dispatch => addEditData
(
    dispatch,
    () => cAPI.exposedFetch({
        path: `/Admin/Integrations/GoogleMerchant/Configuration/Profiles/${encodeURIComponent(profileId)}/DataSource`,
        httpMethod: 'POST'
    }),
    null,
    'googleMerchantConnection',
    false,
    false,
    true,
    true
);

export const getGoogleMerchantOperationalSettings = () => dispatch => getData
(
    dispatch,
    () => cAPI.exposedFetch({
        path: '/Admin/Integrations/GoogleMerchant/OperationalSettings',
        httpMethod: 'GET'
    })
);

export const getGoogleMerchantAccounts = () => dispatch => getData
(
    dispatch,
    () => cAPI.exposedFetch({
        path: '/Admin/Integrations/GoogleMerchant/Accounts',
        httpMethod: 'GET'
    })
);

export const prepareGoogleMerchantProduct = formData => dispatch => getData
(
    dispatch,
    () => cAPI.exposedFetch({
        path:
            `/Admin/Integrations/GoogleMerchant/Configuration/Profiles/${encodeURIComponent(formData.profileId)}` +
            `/Products/${encodeURIComponent(formData.productId)}/Prepared`,
        httpMethod: 'GET'
    })
);

export const markGoogleMerchantProductsDirty = formData => dispatch => addEditData
(
    dispatch,
    payload => cAPI.exposedFetch({
        path: '/Admin/Integrations/GoogleMerchant/ExportState/MarkDirty',
        httpMethod: 'POST',
        jsonBody: payload
    }),
    formData,
    null,
    false,
    false,
    true,
    true
);

export const prepareGoogleMerchantPending = formData => dispatch => addEditData
(
    dispatch,
    payload => cAPI.exposedFetch({
        path: '/Admin/Integrations/GoogleMerchant/ExportState/PreparePending',
        httpMethod: 'POST',
        jsonBody: payload
    }),
    formData,
    null,
    false,
    false,
    true,
    true
);

export const sendGoogleMerchantPrepared = formData => dispatch => addEditData
(
    dispatch,
    payload => cAPI.exposedFetch({
        path: '/Admin/Integrations/GoogleMerchant/ExportState/SendPrepared',
        httpMethod: 'POST',
        jsonBody: payload
    }),
    formData,
    null,
    false,
    false,
    true,
    true
);

export const searchGoogleMerchantExportStates = formData => dispatch => addEditData
(
    dispatch,
    payload => cAPI.exposedFetch({
        path: '/Admin/Integrations/GoogleMerchant/ExportState/Search',
        httpMethod: 'POST',
        jsonBody: payload
    }),
    formData,
    null,
    false,
    false,
    true,
    true
);

export const deleteGoogleMerchantProfile = profileId => dispatch => addEditData
(
    dispatch,
    () => cAPI.exposedFetch({
        path: `/Admin/Integrations/GoogleMerchant/Configuration/Profiles/${encodeURIComponent(profileId)}`,
        httpMethod: 'DELETE'
    }),
    null,
    'googleMerchantConnection',
    false,
    false,
    true,
    true
);

export const createGoogleMerchantProfile = profile => dispatch => addEditData
(
    dispatch,
    payload => cAPI.exposedFetch({
        path: '/Admin/Integrations/GoogleMerchant/Configuration/Profiles',
        httpMethod: 'POST',
        jsonBody: payload
    }),
    profile,
    'googleMerchantConnection',
    false,
    false,
    true,
    true
);

export const updateGoogleMerchantProfile = (profileId, profile) => dispatch => addEditData
(
    dispatch,
    payload => cAPI.exposedFetch({
        path: `/Admin/Integrations/GoogleMerchant/Configuration/Profiles/${encodeURIComponent(profileId)}`,
        httpMethod: 'PUT',
        jsonBody: payload
    }),
    profile,
    'googleMerchantConnection',
    false,
    false,
    true,
    true
);

export const searchGoogleMerchantWorkerHistory = formData => dispatch => addEditData
(
    dispatch,
    payload => cAPI.exposedFetch({
        path: '/Admin/Integrations/GoogleMerchant/WorkerHistory/Search',
        httpMethod: 'POST',
        jsonBody: payload
    }),
    formData,
    null,
    false,
    false,
    true,
    true
);

export const markGoogleMerchantVisibleProductsDirty = formData => dispatch => addEditData
(
    dispatch,
    payload => cAPI.exposedFetch({
        path: '/Admin/Integrations/GoogleMerchant/ExportState/MarkVisibleDirty',
        httpMethod: 'POST',
        jsonBody: payload
    }),
    formData,
    null,
    false,
    false,
    true,
    true
);
export const getGoogleMerchantCategoryExclusions = () => dispatch => getData
(
    dispatch,
    () => cAPI.exposedFetch({
        path: '/Admin/Integrations/GoogleMerchant/Configuration/CategoryExclusions',
        httpMethod: 'GET'
    })
);

export const updateGoogleMerchantCategoryExclusions = formData => dispatch => addEditData
(
    dispatch,
    payload => cAPI.exposedFetch({
        path: '/Admin/Integrations/GoogleMerchant/Configuration/CategoryExclusions',
        httpMethod: 'PUT',
        jsonBody: payload
    }),
    formData,
    null,
    false,
    false,
    true,
    true
);

export const getOperationalIssues = module => dispatch => getData
(
    dispatch,
    () => cAPI.exposedFetch({
        path: `/Admin/OperationalIssues${module ? `?module=${encodeURIComponent(module)}` : ''}`,
        httpMethod: 'GET'
    })
);

export const resolveOperationalIssue = (key, formData = {}) => dispatch => addEditData
(
    dispatch,
    payload => cAPI.exposedFetch({
        path: `/Admin/OperationalIssues/${encodeURIComponent(key)}/Resolve`,
        httpMethod: 'POST',
        jsonBody: payload
    }),
    formData,
    null,
    false,
    false,
    true,
    true
);
